export default "__VITE_ASSET__Gyu1uIcc__"